import { ASSETS } from "./assets-data";

const promotionData = {
    en: {
        seo: {
            title: 'Get 10% Off | BH-Hardware Newsletter',
            description: 'Subscribe to the BH-Hardware newsletter and get 10% off your first wholesale order. Professional garage door parts, shipped fast.',
            keywords: 'BH-Hardware discount, garage door parts coupon, wholesale hardware promo, 10% off'
        },
        badge: 'EXCLUSIVE OFFER',
        discount: '10% OFF',
        headline: 'Your First Order.',
        subheadline: 'Subscribe to our wholesale newsletter and unlock 10% off your first order — plus early access to new arrivals and bulk pricing deals.',
        formTitle: 'Unlock Your Discount',
        formSubtitle: 'Subscribe and get your code instantly.',
        emailPlaceholder: 'Enter your email address',
        submitLabel: 'Get My 10% Off',
        submittingLabel: 'Sending...',
        privacyNote: 'By subscribing you agree to our',
        privacyLink: 'Privacy Policy',
        successHeadline: "You're In.",
        successSubtitle: 'Your discount code is ready. Copy it and use it at checkout.',
        couponEmailNote: 'Check your inbox — your code is on its way.',
        couponCopied: 'Copied!',
        copyLabel: 'Copy Code',
        disclaimer: 'One use per customer. Valid on your first order only. Excludes bulk spring packs.',
        points: [
            { title: 'Same-Day Shipping', detail: 'Orders before 2 PM EST ship today' },
            { title: 'Wholesale Pricing', detail: 'No retail markups — B2B rates only' },
            { title: 'Pro-Grade Quality', detail: 'ASTM-certified, high-cycle components' },
        ],
        backgroundImage: "/placeholder.svg",
    },
    he: {
        seo: {
            title: 'קבלו 10% הנחה | ניוזלטר BH-Hardware',
            description: 'הירשמו לניוזלטר של BH-Hardware וקבלו 10% הנחה על ההזמנה הראשונה שלכם.',
            keywords: 'BH-Hardware קוד הנחה, חלקי דלתות מוסך, קופון סיטונאי'
        },
        badge: 'הצעה בלעדית',
        discount: '10% הנחה',
        headline: 'על ההזמנה הראשונה.',
        subheadline: 'הירשמו לניוזלטר הסיטונאי שלנו וקבלו 10% הנחה על ההזמנה הראשונה — בנוסף לגישה מוקדמת למוצרים חדשים ועסקאות מחיר סיטונאי.',
        formTitle: 'פתחו את ההנחה שלכם',
        formSubtitle: 'הירשמו וקבלו את הקוד מיד.',
        emailPlaceholder: 'הכניסו כתובת אימייל',
        submitLabel: 'קבלו את ה-10% הנחה',
        submittingLabel: 'שולח...',
        privacyNote: 'בהרשמה אתם מסכימים ל',
        privacyLink: 'מדיניות הפרטיות',
        successHeadline: 'אתם פנימה.',
        successSubtitle: 'קוד ההנחה שלכם מוכן. העתיקו אותו והשתמשו בו בקופה.',
        couponEmailNote: 'בדקו את תיבת הדואר — הקוד בדרך אליכם.',
        couponCopied: 'הועתק!',
        copyLabel: 'העתק קוד',
        disclaimer: 'שימוש אחד ללקוח. תקף להזמנה הראשונה בלבד.',
        points: [
            { title: 'משלוח ביום ההזמנה', detail: 'הזמנות לפני 14:00 יוצאות היום' },
            { title: 'מחיר סיטונאי', detail: 'ללא תוספות קמעונאיות — תעריפי B2B' },
            { title: 'איכות מקצועית', detail: 'רכיבים מוסמכים ASTM לאלף מחזורים' },
        ],
        backgroundImage: "/placeholder.svg",
    }
};

export function getPromotionData(language) {
    return promotionData[language === 'he' ? 'he' : 'en'];
}

export default promotionData;
